/**
 * The visual (Quill) editor can't hold tables. A signature laid out with one has to be edited as
 * HTML, or the editor flattens it and the next save stores the flattened version.
 */
export function hasTable(html: string): boolean {
  return /<table[\s>]/i.test(html);
}

/**
 * Image sources that can't be saved: anything that isn't a web address or embedded image data.
 * Outlook's exported signatures point at files on the user's computer, e.g. `Name_files/image001.png`.
 */
export function findUnsupportedImageSources(html: string): string[] {
  const doc = new DOMParser().parseFromString(html, 'text/html');

  return Array.from(doc.querySelectorAll('img'))
    .map((img) => (img.getAttribute('src') ?? '').trim())
    .filter((src) => src && !/^(https?:|data:image\/)/i.test(src));
}
